/* unplugin-vue-components disabled */import { render } from "./Jiuling.vue?vue&type=template&id=a1571cfe"
import script from "./Jiuling.vue?vue&type=script&lang=js"
export * from "./Jiuling.vue?vue&type=script&lang=js"

import "./Jiuling.vue?vue&type=style&index=0&id=a1571cfe&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__